import {useMutation} from '@apollo/react-hooks';

import type {
    UpdateAccountForLead as UpdateAccountForLeadMutation,
    UpdateAccountForLeadVariables as UpdateAccountForLeadMutationVariables,
    AccountUpdateInput,
} from 'nutshell-graphql-types';

import {refetchAccountsAndContactsQueries} from '../../helpers';

import UPDATE_ACCOUNT_FOR_LEAD from '../mutations/update-account-for-lead.graphql';

export const useUpdateAccountForLead = (
    leadId: string
): {
    updateAccount: (arg1: AccountUpdateInput) => Promise<any>;
    isLoading: boolean;
} => {
    const [updateAccount, {loading}] = useMutation<
        UpdateAccountForLeadMutation,
        UpdateAccountForLeadMutationVariables
    >(UPDATE_ACCOUNT_FOR_LEAD);

    return {
        updateAccount: (input: AccountUpdateInput) =>
            updateAccount({
                variables: {input},
                refetchQueries: refetchAccountsAndContactsQueries({leadId}),
                awaitRefetchQueries: true,
            }),
        isLoading: loading,
    };
};
